module.exports = __webpack_public_path__ + "static/media/okki-landing-6.7fe62d96.svg";